export const internalDomainNames = ['@koester-bau.de', '@baresel.de', '@koester-planung.de', '@digacon-software.com'];
